.form {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  min-width: 32rem;
}

.row {
  display: flex;
  gap: 1.2rem;

  > * {
    flex: 1;
    min-width: 0;
  }
}

/* Only the read-only email/phone pair still needs this — every other field is a ui-kit
   component that brings its own label and spacing. No label styling here: `FieldLabel` owns
   that, and the local override this used to carry is exactly why three fields in this one
   form looked different from the rest. */
.field {
  width: 100%;
}

.error {
  color: var(--color-shades-hibiscus);
  font-size: 1.2rem;
}

.readonly {
  margin: 0;
  padding: 0.8rem 0;
  color: var(--color-text-secondary);
}

.hint {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 1.2rem;
}
